module.exports = __webpack_public_path__ + "src/assets/img/meeting_restaurant2.6c97d94a.jpg";